import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import Select from '../Select'
import { useSelectionSet } from '../../hooks/selection-set-functions'

const SelectTessera = () => {
  const availableTessere = useSelector(
    state => state.selection.availableTessere,
  )
  const selectedTessera = useSelector(state => state.selection.selectedTessera)

  const { setSelectedTessera } = useSelectionSet()

  const value = availableTessere?.includes(selectedTessera)
    ? selectedTessera
    : undefined

  return (
    <Grid size={{ xs: 12, md: 2 }}>
      <Select
        id='available-tessere'
        label='Ruolo'
        value={value}
        options={availableTessere}
        autoSelect={false}
        disabled={!availableTessere}
        onChange={setSelectedTessera}
      />
    </Grid>
  )
}

export default SelectTessera
